const l = {}, o = {
  fillColor: "#3734EF",
  fillOpacity: 20,
  fillVisible: !0,
  strokeColor: "#393EB7",
  strokeOpacity: 100,
  strokeVisible: !0,
  strokeWidth: 3
};
export {
  l as BoundaryPolygonDefaultFetchFilter,
  o as BoundaryPolygonDefaultVisualFilter
};
//# sourceMappingURL=index.es108.js.map
